module.exports = __webpack_public_path__ + "static/sindhi-e30621cedcb4523507065a6be26d3983.jpg";